import I18n from 'I18n';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { Text } from 'foundations-components/components/Text';
import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { getStatusSeverity } from 'integrations-lib/utils/connectedAppStatusUtils';
import { StatusSeverityKey } from 'integrations-lib/constants/StatusSeverity';
import { getAppNameByAppId } from 'integrations-lib/constants/AppIds';
import { GoToSettingsButton } from '../../GoToSettingsButton/GoToSettingsButton';
import { trackEvent, EventNames } from '../../../utils/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const getTooltipHeading = (connected, total) => {
  if (connected === total) {
    return '';
  }
  return connected > 0 ? I18n.text('tooltipNeedsAttention.heading') : I18n.text('tooltipDisconnected.heading');
};
const getTooltipMessage = (connected, total) => {
  return connected === total ? '' : I18n.text('tooltipNeedsAttention.message', {
    count: total - connected,
    total
  });
};
export const getMultipleAccountOptions = ({
  accountStatusesList,
  tracker
}) => {
  const {
    appId
  } = accountStatusesList[0];
  const totalAccounts = accountStatusesList.length;
  const connectedAccounts = accountStatusesList.filter(({
    type: statusType
  }) => statusType === AppConnectionStatuses.OK).length;
  const statusText = connectedAccounts > 0 ? `${I18n.text('authorizationStatus.connected')} (${connectedAccounts}/${totalAccounts})` : `${I18n.text('authorizationStatus.disconnected')} (${totalAccounts}/${totalAccounts})`;
  const statusSeverity = connectedAccounts === totalAccounts ? getStatusSeverity(StatusSeverityKey.SUCCESS) : connectedAccounts > 0 ? getStatusSeverity(StatusSeverityKey.WARNING) : getStatusSeverity(StatusSeverityKey.DANGER);
  const tooltipDisabled = connectedAccounts === totalAccounts;
  const tooltipHeadingText = getTooltipHeading(connectedAccounts, totalAccounts);
  const tooltipMessage = getTooltipMessage(connectedAccounts, totalAccounts);
  const content = /*#__PURE__*/_jsx(StatusTag, {
    use: statusSeverity,
    hollow: false,
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "detail-100",
      textDecoration: tooltipDisabled ? 'none' : 'underline',
      children: statusText
    })
  });
  const handleCTAButtonClick = () => {
    const appName = getAppNameByAppId(appId) || '';
    trackEvent(EventNames.PAGE_INTERACTION, {
      action: 'click-go-to-settings-button',
      appId,
      appName
    });
    tracker === null || tracker === void 0 || tracker({
      action: 'click-go-to-settings-button',
      appId,
      appName
    });
  };
  const ctaButton = connectedAccounts < totalAccounts ? /*#__PURE__*/_jsx(GoToSettingsButton, {
    appId: appId,
    onClick: handleCTAButtonClick
  }) : null;
  return {
    content,
    ctaButton,
    tooltipDisabled,
    tooltipHeadingText,
    tooltipMessage
  };
};